module.exports = __webpack_public_path__ + "img/bg-pins-desktop.3e26404.png";